import Head from 'next/head'
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useEventLogging } from '@packages/jslib'

import Layout from '@components/Layout'
import QuestionArea from '@components/QuestionArea'
import useViewResultModeStore from 'store/viewResultMode'

const ExamIndexPage = () => {
  const [timeout, setTimeout] = useState(false)
  const { viewResultMode, setViewResultMode } = useViewResultModeStore()
  const router = useRouter()
  const { isResult } = router.query
  const { trackAction } = useEventLogging()

  useEffect(() => {
    if (isResult === 'true') {
      // 해답 보기 버튼을 누른 뒤 회원가입하고 다시 돌아온 것을 추적하기 위하여 isResult 쿼리가 true일 경우 Come back to Result 액션
      trackAction({
        name: 'Come back to Result',
        properties: {
          isResult: 'true',
        },
      })
      setViewResultMode(true)
    }
  }, [isResult, setViewResultMode, trackAction])

  return (
    <>
      <Head>
        <title>Carepartner CBT</title>
        <meta name="description" content="carepartner 요양보호사 자격시험 모의 CBT" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <main>
        <Layout
          header
          aside
          footer
          setTimeout={setTimeout}
          timeout={timeout}
          trackPageName={viewResultMode ? 'Check for Answers' : 'Exam'}
        >
          <QuestionArea />
        </Layout>
      </main>
    </>
  )
}

export default ExamIndexPage
